import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/Bonus/ById';

export const BONUS_BY_ID_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const BONUS_BY_ID_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;
